module.exports = __webpack_public_path__ + "static/media/shortlink1.a7266e90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Creating/shortlink1.jpg
// module id = 1618
// module chunks = 0